import type { ReactNode } from 'react';
import { CaretDown } from '@phosphor-icons/react';

import { Color } from '@tmh-website/shared/colors';
import DropdownMenu from '@tmh-website/ui/DropdownMenu';
import { FormElementThemeColor } from '@tmh-website/ui/FormElements';

import * as Styled from './EnvironmentSelectButton.styles';
import { EnvironmentSelectButtonBorderThemeColor } from './EnvironmentSelectButton.theme';

/**
 * This component is a special button that is only use for the locale and audience select.
 * The button is not part of "UI" since its quite rare and only used on the website.
 */

export interface EnvironmentSelectButtonProps {
  themeColor: FormElementThemeColor;
  borderColor?: EnvironmentSelectButtonBorderThemeColor;
  iconLeft?: ReactNode;
  label: ReactNode;
  children: ReactNode;
  isSmall?: boolean;
}

const EnvironmentSelectButton = ({
  themeColor,
  borderColor,
  iconLeft,
  label,
  children,
  isSmall,
  ...props
}: EnvironmentSelectButtonProps) => {
  return (
    <DropdownMenu
      themeColor={Color.Neutral_200_OffWhite}
      anchorEl={
        <Styled.Container
          $themeColorColor={themeColor}
          $borderColor={borderColor}
          $hasIconLeft={!!iconLeft}
          $isSmall={isSmall}
          {...props}>
          <Styled.Label>
            {iconLeft}
            <span>{label}</span>
          </Styled.Label>
          <CaretDown weight='bold' style={{ flexShrink: 0 }} />
        </Styled.Container>
      }>
      {children}
    </DropdownMenu>
  );
};

export default EnvironmentSelectButton;
